import { render, staticRenderFns } from "./InspirationDescription.vue?vue&type=template&id=de5787c2"
import script from "./InspirationDescription.vue?vue&type=script&lang=ts"
export * from "./InspirationDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports